import React from "react";
import styled from "styled-components";
import arrowIcon from "../../assets/images/ico_arrow.gif";

const StyledDiv = styled.div`
  margin: 20px 0 15px;

  span {
    color: #000;

    &:after {
      content: "";
      background: url(${arrowIcon}) no-repeat;
      width: 5px;
      height: 9px;
      display: inline-block;
      margin: 0 10px;
    }

    &:last-child {
      color: #00aad2;
    }

    &:last-child:after {
      width: 0;
    }
  }
`;

const BreadCrumbDiv = ({ items }) => {
  return (
    <StyledDiv>
      {items.map((item, index) => (
        <span key={index}>{item}</span>
      ))}
    </StyledDiv>
  );
};

export default BreadCrumbDiv;
